import * as React from 'react'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Grid, InputLabel, Input, FormControl } from '@material-ui/core'

import DivisionSelection from './DivisionSelection'
import MaskInput from '../shared/MaskInput'
import DateInput from '../shared/DateInput'
import HeightInput from './HeightInput'
import IContest, { ICompetitorLevel } from 'src/models/IContest'
import { IEntry } from 'src/models/IOrder'
import IDictionary from 'src/models/IDictionary'

interface IEntryProps {
  onDivisionsChange: (divisions: string[]) => void
  contest: IContest
  entry: IEntry
  selectedLevel: ICompetitorLevel
  onChange: React.ChangeEventHandler
  onDateChange: (date?: Date) => void
  onBlur: (e: any) => void
  validateEntry: IDictionary<boolean>
  birthdateInvalid: boolean
  last4SSNInvalid: boolean
}

const Entry: React.SFC<IEntryProps> = props => {
  const {
    contest,
    entry,
    onChange,
    onBlur,
    onDateChange,
    onDivisionsChange,
    selectedLevel,
    validateEntry,
    last4SSNInvalid
  } = props

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Competitor Info
      </Typography>

      <Grid container spacing={16}>
        <DivisionSelection
          selectedLevel={selectedLevel}
          selectedDivisions={entry.divisions}
          onChange={onDivisionsChange}
          contest={contest}
        />
        <Grid item xs={12}>
          <DateInput date={entry.birthdate} onChange={onDateChange} />
        </Grid>
        <HeightInput
          onChange={onChange}
          onBlur={onBlur}
          heightFeet={entry.heightFeet}
          heightInches={entry.heightInches}
          validateEntry={validateEntry}
        />
        {selectedLevel.requiresWeight && (
          <Grid item xs={12}>
            <FormControl
              fullWidth
              required
              error={validateEntry.weight && entry.weight === undefined}>
              <InputLabel>Weight</InputLabel>
              <Input
                name="weight"
                fullWidth
                value={(entry.weight || '').toString()}
                onChange={onChange}
                onBlur={onBlur}
                inputComponent={MaskInput}
                inputProps={{
                  mask: [/\d/, /\d/, /\d/]
                }}
              />
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12}>
          <FormControl
            fullWidth
            required
            error={validateEntry.last4SSN && last4SSNInvalid}>
            <InputLabel>Last 4 SSN</InputLabel>
            <Input
              name="last4SSN"
              fullWidth
              value={entry.last4SSN}
              onChange={onChange}
              onBlur={onBlur}
              inputComponent={MaskInput}
              inputProps={{
                mask: [/\d/, /\d/, /\d/, /\d/]
              }}
            />
            {validateEntry.last4SSN &&
              last4SSNInvalid && <FormHelperText>Invalid SSN</FormHelperText>}
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="occupation"
            value={entry.occupation}
            onChange={onChange}
            label="Occupation"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="trainer"
            value={entry.trainer}
            onChange={onChange}
            label="Trainer"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="thankYou"
            value={entry.thankYou}
            onChange={onChange}
            label="Thank you message"
            fullWidth
            multiline
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Entry



// WEBPACK FOOTER //
// ./src/components/contest/Entry.tsx